import { http } from '../../../../api/http';
import type { Deposito, Ubicacion } from '../types/almacen.types';

export const almacenService = {
  async getAll(): Promise<Deposito[]> {
    const response = await http.get('/deposito');
    return response.data;
  },

  async getById(id: number): Promise<Deposito> {
    const response = await http.get(`/deposito/${id}`);
    return response.data;
  },

  async save(deposito: Deposito): Promise<Deposito> {
    const response = await http.post('/deposito', deposito);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await http.delete(`/deposito/${id}`);
  },

  async getUbicaciones(idDeposito: number): Promise<Ubicacion[]> {
    const response = await http.get(`/deposito/${idDeposito}/ubicaciones`);
    return response.data;
  },

  async saveUbicacion(ubicacion: Ubicacion): Promise<Ubicacion> {
    const response = await http.post('/deposito/ubicacion', ubicacion);
    return response.data;
  },

  async deleteUbicacion(id: number): Promise<void> {
    await http.delete(`/deposito/ubicacion/${id}`);
  },
};
